import _ from 'lodash'

type Props = {
  checked?: boolean
  className?: string
  label: string | React.ReactNode
  value?: string | number | null | any
  disabled?: boolean
  onChange: (val: any) => void
} & React.ComponentPropsWithoutRef<'input'>

export function Checkbox({ id, name, label, checked, onChange }: Props) {
  return (
    <div className='flex items-start hover:cursor-pointer w-full py-1'>
      <div className='flex h-6 shrink-0 items-center'>
        <div className='group grid size-4 grid-cols-1'>
          <input id={id || name} type='checkbox' className='form-checkbox'
            checked={checked}
            onChange={e => onChange(e.target.checked)}
          />
          <svg fill='none' viewBox='0 0 14 14'
            className='pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25'
          >
            <path d='M3 8L6 11L11 3.5' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' className='opacity-0 group-has-checked:opacity-100' />
            <path d='M3 7H11' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' className='opacity-0 group-has-indeterminate:opacity-100' />
          </svg>
        </div>
      </div>
      <label htmlFor={id || name} className='form-inline-label mt-0.5 px-2'>
        {label}
      </label>
    </div>
  )
}